<label class="label">
  <span [style.display]="'flex'"
        [style.align-items]="'baseline'"
        [style.gap.px]="5">
    <span>{{ props.label || 'Value'}}</span>
    @if(props['labelTooltip']) {
    <mat-icon [style.font-size.rem]="1.2"
              [style.margin-left.px]="5"
              [matTooltip]="props['labelTooltip']"
              matTooltipPosition="above"
              matTooltipClass="label-tooltip">info</mat-icon>
    }
  </span>
  @if(formControl.value !== undefined && formControl.value !== null) {
  <strong [style.font-size.rem]="1.2">{{ formControl.value }}</strong>
  }
  @else {
  <span [style.font-size.rem]="1.2">Not set</span>
  }
</label>
<ng-container #fieldComponent />